<template>
  <!--个人信息页面-->
  <tk-container
    class="container"
    :status="status"
    @refresh="getInit"
  >
    <!--头部-->
    <tkui-header class="b-b-f" center slot="header">
      <div slot="left-menu" @click="$back">
        <tkui-button class="icon">
          <tk-icon size="16">return</tk-icon>
        </tkui-button>
      </div>
      我的资料
      <div
        slot="right-menu"
        @click="editorProfile"
      >
        <tkui-button class="small primary header-editor-btn">保存</tkui-button>
      </div>
    </tkui-header>
    <!--个人信息-->
    <!--头像-->
    <tk-flex
      class="flex-list flex-border p-x-12 p-t-16"
      column
      @click.native="checkImage"
      style="padding-bottom: 8px;"
    >
      <tk-flex class="full-width" between middle>
        <span class="flex-list-item">头像</span>
        <tk-flex middle>
          <tk-avatar style="background: white;" size="32" class="m-r-15" v-if="avatarWaiting">
            <div class="flex-list-item">
              <tk-spinner type="oval" color="rgba(153, 153, 153, 1)" size="25"></tk-spinner>
            </div>
          </tk-avatar>
          <tk-avatar style="background: white;" size="32" class="m-r-15" v-else-if="avatarSrc && !avatarWaiting">
            <tk-image :src="avatarSrc" quality="100" :width="32" :height="32"></tk-image>
          </tk-avatar>
          <tk-icon size="12" color="#999">rightarrow</tk-icon>
        </tk-flex>
      </tk-flex>
    </tk-flex>
    <!--头像裁剪-->
    <cropper :cropper-cover="cropperStatus" @changCover="emitChange" @upLoadImage="emitUpload" :user-img="cropperImage"></cropper>
    <!--姓名-->
    <tk-flex class="flex-list flex-border p-x-12" :class="{ 'tk-noios-disabled': !$tkUa.isIos }">
      <tkui-input :disabled="true" class="flex-list-input" label="姓名" noborder v-model="fullName"></tkui-input>
    </tk-flex>
    <!--手机号-->
    <tk-flex class="flex-list flex-border p-x-12" :class="{ 'tk-noios-disabled': !$tkUa.isIos }">
      <tkui-input :disabled="true" class="flex-list-input" type="telephone" rulers="required" label="手机" noborder v-model="userInfo.phone"></tkui-input>
    </tk-flex>
    <!--选择性别-->
    <tk-flex class="flex-list flex-line p-b-2 flex-gender p-x-12" :class="{ 'factory-class': isFactoryAccount, 'disabled-icon': isSex }">
      <tkui-list class="full-width" v-if="showPicker">
        <tkui-list-picker left v-model="gender" :disabled="editDisabled || isSex" :items="{man: '男', woman: '女'}" label="性别" placeholder="请选择"></tkui-list-picker>
      </tkui-list>
    </tk-flex>
    <!--生日(公历/农历)-->
    <tk-flex class="flex-list flex-line flex-birthday p-x-12" v-if="isCountyAccount" :class="{ 'disabled-icon': isCalendar }">
      <tkui-list class="full-width" v-if="showPicker">
        <tkui-list-picker left v-model="birthdayType" :disabled="editDisabled ||isCalendar" :items="{lunar: '农历', calendar: '公历'}" label="公历农历" placeholder="请选择"></tkui-list-picker>
      </tkui-list>
    </tk-flex>
    <!--生日日期-->
    <tk-flex between class="flex-list flex-line p-x-12 disabled-icon" :class="{ 'disabled-icon': isDate }"  v-if="isCountyAccount">
      <tkui-list class="full-width" v-if="showPicker">
        <tkui-list-picker left v-model="birthday" type="date" :disabled="editDisabled || isDate" :min="'1910'" :max="new Date().toISOString()" label="生日日期" placeholder="请选择"></tkui-list-picker>
      </tkui-list>
    </tk-flex>
    <!--门店地址-->
    <tk-flex class="flex-list flex-line p-x-12" v-if="!isFactoryAccount">
      <tkui-list class="full-width" v-if="showPicker">
        <tkui-list-picker style="border: 0;" class="full-width" :disabled="editDisabled" type="region" v-model="region" left label="门店地址" :regionFilter="regionFilter" placeholder="请选择"></tkui-list-picker>
      </tkui-list>
    </tk-flex>
    <!--门店详细地址-->
    <tk-flex column class="flex-list flex-border account-basic-detail p-x-12" v-if="!isFactoryAccount">
      <div class="compatible-input font-14 p-t-16" style="font-weight: 500;">详细地址</div>
      <tkui-input class="flex-list-input" :disabled="editDisabled"  label="" :place-holder="'默认收货地址，请您详细填写'" noborder v-model="address"></tkui-input>
    </tk-flex>
    <!--退出弹框-->
    <tkui-dialog :show.sync="isShowOut" center>
      <div class="subhead">
        您确定要退出登录吗？
      </div>
      <template slot="action">
        <button class="tkui-dialog-button" @click="isShowOut = false">取消</button>
        <button class="tkui-dialog-button primary" @click="loginOut">确定</button>
      </template>
    </tkui-dialog>
    <!--登出按钮-->
    <div class="login-out">
      <tkui-button class="block primary raised login-out-btn" @click="isShowOut = true">退出登录</tkui-button>
      <div style="height: 20px;"></div>
    </div>
  </tk-container>
</template>

<script>
import cropper from '@/components/cropper'
export default {
  components: {
    cropper
  },
  data () {
    return {
      status: 'loading', // 页面状态
      showPicker: false,
      isShowCalendar: false, // 选择日期
      isShowOut: false, // 是否退出提示
      avatarWaiting: false, // 上传图片状态
      editDisabled: false, // 编辑状态
      cropperStatus: false, // 裁剪图片的状态
      cropperImage: '', // 需要裁剪图片的路径
      defaultAddress: null, // 默认地址数据
      regionFilter: { // 地理位置
        root: '130000'
      },
      avatar: '', // 头像
      gender: null, // 性别
      birthdayType: '', // 生日类型
      birthday: '', // 生日日期
      region: '', // 门店所在地区
      address: '' // 门店详细地址
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.getInit()
  },
  computed: {
    // 头像src
    avatarSrc () {
      if (!this.userInfo) { return this.avatar ? this.avatar : this.defaultImage }
      if (!this.userInfo.avatar) { return this.avatar ? this.avatar : this.defaultImage }
      return this.avatar ? this.avatar : this.userInfo.avatar
    },
    // 用户姓名
    fullName () {
      if (!this.userInfo) { return '用户' }
      return this.userInfo.name ? this.userInfo.name : '用户'
    },
    // 性别
    isSex () {
      if (this.userInfo && this.userInfo.gender) {
        return true
      }
      return false
    },
    // 公历农历
    isCalendar () {
      if (this.userInfo && this.userInfo.birthdayType) {
        return true
      }
      return false
    },
    // 生日日期
    isDate () {
      if (this.userInfo && this.userInfo.birthday) {
        return true
      }
      return false
    }
  },
  methods: {
    /**
    * 页面初始化
    * @date: 2020/4/13
    */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getUserAddress() // 获取用户地址
        this.gender = this.userInfo.gender ? this.userInfo.gender : null
        this.birthdayType = this.userInfo.birthdayType ? this.userInfo.birthdayType : ''
        this.avatar = this.userInfo.avatar ? this.userInfo.avatar : this.defaultImage
        let isoString = ''
        if (this.userInfo.birthday) {
          if (typeof this.userInfo.birthday === 'object') {
            isoString = this.userInfo.birthday.iso
          } else {
            isoString = this.userInfo.birthday
          }
        }
        this.birthday = isoString
        this.showPicker = true
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.showPicker = true
        this.$tkGlobal.toast.add('数据加载失败')
      }
    },
    /**
    * 获取用户地址
    * @date: 2020/4/14
    */
    async getUserAddress () {
      let defaultAddress = await this.$tkParse.getList('/classes/shippingAddress', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId,
            default: 'yes'
          }
        }
      })
      if (defaultAddress.length) {
        this.region = defaultAddress[0].region
        this.address = defaultAddress[0].address
        this.defaultAddress = defaultAddress[0]
      } else {
        this.defaultAddress = null
      }
    },
    /**
     * 取消裁剪图片
     * @date: 2020/9/3
     */
    emitChange (e) {
      this.cropperStatus = e
      this.avatarWaiting = false
    },
    /**
     * 上传图片
     * @date: 2020/4/13
     */
    async checkImage () {
      if (this.editDisabled) { return }
      if (this.avatarWaiting) { return this.$tkGlobal.toast.add('您点的太快了') }
      // 校验格式
      let file = await this.$tkFile.pick({
        type: 'image/*',
        from: 'file' })
      const allImgExt = ['jpg', 'jpeg', 'bmp', 'png']
      if (!allImgExt.includes(file.ext)) {
        this.$tkGlobal.toast.add('请上传图片')
        return
      }
      this.avatarWaiting = true
      this.cropperStatus = true
      this.cropperImage = 'data:image/png;base64,' + Buffer.from(file.buffer, 'utf8').toString('base64')
    },
    /**
     * 上传裁剪后的图片
     * @date: 2020/9/3
     */
    emitUpload ({ url, status }) {
      this.avatarWaiting = status
      if (url) {
        this.avatar = url
        this.$tkGlobal.toast.add('头像上传成功')
      }
    },
    /**
    * 编辑个人信息
    * @date: 2020/4/14
    */
    async editorProfile () {
      try {
        this.status = 'waiting'
        let date = new Date(this.birthday)
        let month = date ? date.getMonth() + 1 : 0
        let day = date ? date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate().toString() : 0
        let obj = {
          gender: this.gender,
          avatar: this.avatar ? this.avatar : this.defaultImage
        }
        if (this.isCountyAccount && this.birthday) {
          obj.birthdayType = this.birthdayType || ''
          obj.birthday = this.birthday
          obj.birthDayYear = date ? date.getFullYear() : 0
          obj.birthDayMonthDay = Number(month.toString() + day.toString())
        }
        await this.$store.dispatch('updateUserMsg', obj)
        if (this.defaultAddress) {
          await this.$tkParse.put(`/classes/shippingAddress/${this.defaultAddress.objectId}`, { region: this.region, address: this.address })
        } else {
          await this.$tkParse.post('/classes/shippingAddress', {
            name: this.fullName,
            user: this.userInfo.objectId,
            phone: this.userInfo.phone,
            region: this.region,
            address: this.address,
            default: 'yes'
          })
        }
        await this.getInit()
        this.$tkGlobal.toast.add('修改个人资料成功')
        this.status = false
      } catch (e) {
        this.status = false
        this.$tkGlobal.toast.add('编辑个人资料失败')
      }
    },
    /**
    * 退出登录
    * @date: 2020/4/13
    */
    async loginOut () {
      this.$store.commit('setSessionToken', null)
      this.$store.commit('setUser', null)
      this.$tkParse.setSessionToken('')
      this.$tkGlobal.toast.add('登出成功')
      this.$cleanHistory()
      if (this.$store.state.user || this.$store.state.sessionToken) {
        this.$cleanHistory()
      }
      this.$cloudAjax.config.headers = null
      this.$replace('/common/login')
    }
  }
}
</script>
<style lang="scss" scoped>
  /*头部样式*/
  .header-editor-btn {
    background: rgba(244, 83, 66, 1) !important;
    color: #F5F5F5 !important;
    min-width: 54px !important;
    height: 26px !important;
    border-radius: 13px !important;
  }
  /*#F41915*/
  .tkui-list-item {
    border-bottom: 0;
  }
  /*行样式*/
  .flex-list {
    width:100%;
    background-color: white;
    .flex-list-item {
      font-size: 14px;
      color: rgba(34, 34, 34, 1);
      line-height:10px;
    }
    .flex-list-input {
      width: 100%;
    }
    .flex-list-input ::placeholder {
      font-size: 14px;
      color: rgba(191, 191, 191, 1);
    }
  }
  .flex-border {
    border-bottom: 1px solid #f5f5f5;
  }
  /*厂家去掉下华线*/
  .factory-class {
    ::v-deep {
      .tkui-list-item {
        border-bottom: none;
      }
    }
  }
  /*退出按钮样式*/
  .login-out {
    margin-top: 7px;
    .login-out-btn {
      height: 57px;
      background-color: white !important;
      color: rgba(235, 83, 15, 1);
      margin: 0;
    }
  }
  /*修改tkui样式*/
  .flex-gender {
    ::v-deep {
      .list-item-content {
        margin-left: 28px;
      }
    }
  }
  .flex-birthday {
    ::v-deep {
      .tkui-list .tkui-list-item .left {
        padding-right: 14px !important;
      }
    }
  }
  ::v-deep {
    .tkui-list .tkui-list-item .left .tkui-list-picker-label {
      padding-top: 1px;
    }
  }
  .tk-noios-disabled {
    ::v-deep {
      .tkui-input-container.disabled input {
        color: #999 !important;
      }
      .tkui-input-container.disabled {
        opacity: 1 !important;
      }
    }
  }
  /*下拉选择去掉边线*/
  ::v-deep .tkui-list-item {
    border: none;
  }
  /*下拉添加边线*/
  .flex-line {
    border-bottom: 1px solid #f5f5f5;
  }
  ::v-deep .account-basic-detail .tkui-input-container .tkui-input-body-warp .tkui-input-body {
    margin-top: 8px !important;
  }
  ::v-deep .tkui-list-picker-icon {
    width: 20px;
    height: 20px;
  }
  /*disabled去掉下拉按钮*/
  .disabled-icon {
    ::v-deep .tkui-list-picker-icon {
      display: none;
    }
  }
</style>
